"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[968],{

/***/ 20968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ monday_demo_tabs_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tab-asset/monday-demo-tabs-assets.scss.js

var StyledMondayDemoTabsAsset = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1g4r5w50"
})("position:absolute;opacity:0;top:0;width:100%;&.current{opacity:1;}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tab-asset/monday-demo-tabs-asset.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var MondayDemoTabsAsset = function(props) {
    var asset = props.asset, onVideoEnded = props.onVideoEnded, setVideoDuration = props.setVideoDuration, isCurrent = props.isCurrent, autoPlay = props.autoPlay;
    var assetWithAutoplay = (0,react.useMemo)(function() {
        return _object_spread_props(_object_spread({}, asset), {
            video: _object_spread_props(_object_spread({}, asset.video), {
                autoPlay: autoPlay,
                playWhenVisible: false
            })
        });
    }, [
        asset,
        autoPlay
    ]);
    var renderAssetComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, assetWithAutoplay), {
            onEnded: onVideoEnded,
            onDuration: setVideoDuration,
            hideControls: true
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMondayDemoTabsAsset, {
        className: classnames_default()("monday-demo-tabs-asset-wrapper", {
            current: isCurrent
        }),
        children: renderAssetComponent()
    });
};
/* harmony default export */ var monday_demo_tabs_asset = (MondayDemoTabsAsset);

// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 22 modules
var button_button = __webpack_require__(16430);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-timeline/monday-demo-timeline.scss.js



var INDICATION_SIZE = 16;
var INDICATION_SIZE_STRING = "".concat(INDICATION_SIZE, "px");
var PROGRESS_BAR_WIDTH = 2;
var PROGRESS_BAR_WIDTH_STRING = "".concat(PROGRESS_BAR_WIDTH, "px");
var StyledMondayDemoTimeline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1umak2b0"
})("display:flex;flex-direction:column;padding:56px 32px 0;min-width:320px;max-width:400px;&.dark-theme{.timeline-tab-indication-label-and-progress-bar-wrapper{&.selected{.timeline-tab-indication-and-label-wrapper{.timeline-tab-indication{.timeline-tab-indication-outer-circle{border-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}.timeline-tab-indication-and-label-wrapper{.timeline-tab-indication{.timeline-tab-indication-outer-circle{.timeline-tab-indication-inner-circle{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}.timeline-progress-bar-wrapper{.timeline-progress-bar{.timeline-progress-bar-empty,.timeline-progress-bar-filled{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}}.button-wrapper{display:flex;margin-top:40px;}");
var StyledTimelineTabIndicationLabelAndProgressBarWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1umak2b1"
})("display:flex;flex-direction:column;cursor:pointer;&.selected{.timeline-tab-indication-and-label-wrapper{.timeline-tab-indication{opacity:1;.timeline-tab-indication-outer-circle{border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}.timeline-tab-label{font-weight:500;}}.timeline-progress-bar-wrapper{.timeline-progress-bar{.timeline-progress-bar-filled{height:100%;animation:fill-progress-bar linear;animation-duration:", function(param) {
    var animationDuration = param.animationDuration;
    return animationDuration;
}, ";}}}}&.watched{.timeline-tab-indication-and-label-wrapper{.timeline-tab-indication{opacity:1;}}.timeline-progress-bar-wrapper{.timeline-progress-bar{.timeline-progress-bar-filled{height:100%;}}}&.selected{.timeline-progress-bar-wrapper{.timeline-progress-bar{.timeline-progress-bar-filled{height:0%;}}}}}&:hover{.timeline-tab-indication-and-label-wrapper{.timeline-tab-indication{opacity:1;}}}.timeline-tab-indication-and-label-wrapper{display:flex;align-items:center;gap:16px;.timeline-tab-indication{opacity:0.24;transition:opacity 0.15s ease-in-out;.timeline-tab-indication-outer-circle{width:", INDICATION_SIZE_STRING, ";height:", INDICATION_SIZE_STRING, ";border-radius:", "".concat(INDICATION_SIZE / 2, "px"), ";border:1px solid transparent;display:flex;transition:border-color 0.15s ease-in-out;.timeline-tab-indication-inner-circle{border-radius:", "".concat(INDICATION_SIZE / 2, "px"), ";background-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";margin:2px;flex:1;}}}.timeline-tab-label{font-size:0.875rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:22px;}}.timeline-progress-bar-wrapper{.timeline-progress-bar{width:", PROGRESS_BAR_WIDTH_STRING, ";height:36px;margin-left:", "".concat(INDICATION_SIZE / 2 - 1, "px"), ";position:relative;.timeline-progress-bar-empty,.timeline-progress-bar-filled{border-radius:", PROGRESS_BAR_WIDTH_STRING, ";background-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";width:100%;}.timeline-progress-bar-empty{height:100%;opacity:0.24;}.timeline-progress-bar-filled{height:0%;position:absolute;top:0;transition:height 0.15s ease-in-out;}}}@keyframes fill-progress-bar{from{height:0%;}to{height:100%;}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-timeline/monday-demo-timeline.js
function monday_demo_timeline_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_demo_timeline_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_demo_timeline_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_demo_timeline_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_demo_timeline_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_demo_timeline_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var MondayDemoTimeline = function(props) {
    var tabs = props.tabs, selectedTab = props.selectedTab, buttonConfig = props.buttonConfig, buttonHighlighted = props.buttonHighlighted, wasComponentEverVisible = props.wasComponentEverVisible, onTabClick = props.onTabClick, videoDuration = props.videoDuration, theme = props.theme;
    var getButtonProps = function() {
        switch(buttonConfig.buttonType){
            case button_consts/* SIGNUP_BUTTON_TYPE */.ge:
                return monday_demo_timeline_object_spread_props(monday_demo_timeline_object_spread({}, buttonConfig), {
                    buttonSize: button_component.XS,
                    invert: !buttonHighlighted
                });
            default:
                return buttonConfig;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMondayDemoTimeline, {
        className: classnames_default()("monday-demo-tabs-timeline-and-labels-wrapper", {
            "dark-theme": (0,segments_service/* isDarkTheme */.$o)(theme)
        }),
        role: "tablist",
        children: [
            tabs.map(function(tab, index) {
                var isSelected = index === selectedTab;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTimelineTabIndicationLabelAndProgressBarWrapper, {
                    className: classnames_default()("timeline-tab-indication-label-and-progress-bar-wrapper", {
                        selected: isSelected && wasComponentEverVisible && !buttonHighlighted,
                        watched: index < selectedTab || buttonHighlighted
                    }),
                    onClick: function(e) {
                        return onTabClick({
                            index: index
                        });
                    },
                    animationDuration: index <= selectedTab ? "".concat(videoDuration, "s") : "unset",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "timeline-tab-indication-and-label-wrapper",
                            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(function(e) {
                                return onTabClick({
                                    index: index
                                });
                            }),
                            role: "tab",
                            "aria-selected": isSelected,
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "timeline-tab-indication",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "timeline-tab-indication-outer-circle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "timeline-tab-indication-inner-circle"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "timeline-tab-label",
                                    children: tab.tabLabel
                                })
                            ]
                        }),
                        index < tabs.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "timeline-progress-bar-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "timeline-progress-bar",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "timeline-progress-bar-empty"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "timeline-progress-bar-filled"
                                    })
                                ]
                            })
                        })
                    ]
                }, index);
            }),
            buttonConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("button-wrapper"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, monday_demo_timeline_object_spread({}, getButtonProps()))
            })
        ]
    });
};
/* harmony default export */ var monday_demo_timeline = (MondayDemoTimeline);

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-desktop-component/monday-demo-tabs-desktop-component.scss.js


var StyledMondayDemoTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1h64g2p0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.monday-demo-tabs-asset-and-timeline{display:flex;gap:24px;justify-content:center;.monday-demo-tabs-assets-wrapper{position:relative;max-width:900px;width:900px;max-height:680px;height:680px;}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-desktop-component/monday-demo-tabs-desktop-component.js

function monday_demo_tabs_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_demo_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_demo_tabs_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_demo_tabs_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_demo_tabs_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_demo_tabs_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var DEMO_FINISHED_SELECTED_TAB_INDEX = -1;
var MondayDemoTabsDesktopComponent = function(props) {
    var tabs = props.tabs, rest = _object_without_properties(props, [
        "tabs"
    ]);
    var tabsWithVideoPlayerRefs = [];
    tabs.forEach(function(tab) {
        tabsWithVideoPlayerRefs.push(monday_demo_tabs_desktop_component_object_spread_props(monday_demo_tabs_desktop_component_object_spread({}, tab), {
            asset: monday_demo_tabs_desktop_component_object_spread_props(monday_demo_tabs_desktop_component_object_spread({}, tab.asset), {
                video: monday_demo_tabs_desktop_component_object_spread_props(monday_demo_tabs_desktop_component_object_spread({}, tab.asset.video), {
                    videoPlayerRef: (0,react.useRef)(null)
                })
            })
        }));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MondayDemoTabsComponentInner, monday_demo_tabs_desktop_component_object_spread({
        tabs: tabsWithVideoPlayerRefs
    }, rest));
};
var MondayDemoTabsComponentInner = function(props) {
    var _tabs_;
    var fullParagraph = props.fullParagraph, tabs = props.tabs, buttonConfig = props.buttonConfig, theme = props.theme;
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)(false), wasComponentEverVisible = ref1[0], setWasComponentEverVisible = ref1[1];
    var ref2 = (0,react.useState)([]), videoDurations = ref2[0], setVideoDurations = ref2[1];
    var ref3 = (0,react.useState)(false), buttonHighlighted = ref3[0], setButtonHighlighted = ref3[1];
    var VISIBILITY_SENSOR_OFFSET = 100;
    var onTabClick = function(param) {
        var index = param.index;
        setSelectedTab(index);
        setButtonHighlighted(false);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
            kind: tabs === null || tabs === void 0 ? void 0 : tabs[index].tabLabel,
            info1: index
        });
    };
    var onVideoEnded = function(index) {
        if (index < tabs.length - 1) {
            setSelectedTab(index + 1);
        }
        // last tab
        if (index === tabs.length - 1) {
            setSelectedTab(DEMO_FINISHED_SELECTED_TAB_INDEX); // demo finished
            setButtonHighlighted(true);
        }
    };
    var setVideoDuration = function(index, duration) {
        if (videoDurations[index] !== duration) {
            var newVideoDurations = (0,_to_consumable_array/* default */.Z)(videoDurations);
            newVideoDurations[index] = duration;
            setVideoDurations(newVideoDurations);
        }
    };
    var getCurrentAsset = function(index) {
        var _tabs_index;
        if (index === DEMO_FINISHED_SELECTED_TAB_INDEX) {
            var _tabs_;
            return tabs === null || tabs === void 0 ? void 0 : (_tabs_ = tabs[tabs.length - 1]) === null || _tabs_ === void 0 ? void 0 : _tabs_.asset;
        }
        return tabs === null || tabs === void 0 ? void 0 : (_tabs_index = tabs[index]) === null || _tabs_index === void 0 ? void 0 : _tabs_index.asset;
    };
    var onVisibilityChange = function(isVisible) {
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    (0,react.useEffect)(function() {
        var _tabs_selectedTab_asset_video_videoPlayerRef_current, _tabs_selectedTab_asset_video_videoPlayerRef, _tabs_selectedTab_asset_video, _tabs_selectedTab_asset, _tabs_selectedTab;
        tabs === null || tabs === void 0 ? void 0 : (_tabs_selectedTab = tabs[selectedTab]) === null || _tabs_selectedTab === void 0 ? void 0 : (_tabs_selectedTab_asset = _tabs_selectedTab.asset) === null || _tabs_selectedTab_asset === void 0 ? void 0 : (_tabs_selectedTab_asset_video = _tabs_selectedTab_asset.video) === null || _tabs_selectedTab_asset_video === void 0 ? void 0 : (_tabs_selectedTab_asset_video_videoPlayerRef = _tabs_selectedTab_asset_video.videoPlayerRef) === null || _tabs_selectedTab_asset_video_videoPlayerRef === void 0 ? void 0 : (_tabs_selectedTab_asset_video_videoPlayerRef_current = _tabs_selectedTab_asset_video_videoPlayerRef.current) === null || _tabs_selectedTab_asset_video_videoPlayerRef_current === void 0 ? void 0 : _tabs_selectedTab_asset_video_videoPlayerRef_current.seekTo(0);
    }, [
        selectedTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMondayDemoTabsDesktopComponent, {
            className: "monday-demo-tabs-desktop-component",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, monday_demo_tabs_desktop_component_object_spread({}, fullParagraph)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "monday-demo-tabs-asset-and-timeline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "monday-demo-tabs-assets-wrapper",
                            children: [
                                tabs.map(function(tab, index) {
                                    return wasComponentEverVisible && index <= videoDurations.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_demo_tabs_asset, {
                                        selectedTab: selectedTab,
                                        index: index,
                                        isCurrent: selectedTab === index,
                                        asset: getCurrentAsset(index),
                                        onVideoEnded: function() {
                                            return onVideoEnded(index);
                                        },
                                        // play only the current video excluding final button step's video (so triggers when video is done won't be fired)
                                        autoPlay: selectedTab === index && index !== DEMO_FINISHED_SELECTED_TAB_INDEX,
                                        setVideoDuration: function(duration) {
                                            return setVideoDuration(index, duration);
                                        }
                                    }, index) : null;
                                }),
                                wasComponentEverVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_demo_tabs_asset, {
                                    selectedTab: selectedTab,
                                    index: DEMO_FINISHED_SELECTED_TAB_INDEX,
                                    isCurrent: selectedTab === DEMO_FINISHED_SELECTED_TAB_INDEX,
                                    // show last video first frame
                                    asset: tabs === null || tabs === void 0 ? void 0 : (_tabs_ = tabs[tabs.length - 1]) === null || _tabs_ === void 0 ? void 0 : _tabs_.asset,
                                    // play the last video so it would stay on the last frame
                                    autoPlay: true,
                                    onVideoEnded: onVideoEnded
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_demo_timeline, {
                            theme: theme,
                            tabs: tabs,
                            selectedTab: selectedTab,
                            buttonConfig: buttonConfig,
                            buttonHighlighted: buttonHighlighted,
                            wasComponentEverVisible: wasComponentEverVisible,
                            onTabClick: onTabClick,
                            videoDuration: videoDurations[selectedTab]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var monday_demo_tabs_desktop_component = (MondayDemoTabsDesktopComponent);

;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-plain-button.scss.js



var StyledMobileTabNavPlainButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqxyx490"
})("font-size:0.875rem;font-weight:300;padding:0 16px;line-height:28px;white-space:nowrap;&:not(.selected){opacity:0.6;}&.selected{.tab-nav-plain-button-text-number,.tab-nav-plain-button-text-label{font-weight:500;}.tab-nav-plain-button-text-label{text-decoration:underline;}}&.background-gray{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-plain-button.js



var MobileTabNavPlainButton = function(props) {
    var tabNumber = props.tabNumber, label = props.label, selected = props.selected, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileTabNavPlainButton, {
        className: classnames_default()("tab-nav-plain-button", {
            selected: selected
        }, theme),
        children: [
            tabNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tab-nav-plain-button-text-number",
                children: "".concat(tabNumber, ". ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tab-nav-plain-button-text-label",
                children: label
            })
        ]
    });
};
/* harmony default export */ var mobile_tab_nav_plain_button = (MobileTabNavPlainButton);

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-mobile-component/monday-demo-tabs-mobile-component.scss.js



var StyledMondayDemoTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "elc861x0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, 'px;margin:auto;.monday-demo-tabs-assets-wrapper{position:relative;.monday-demo-tabs-asset-click-wrapper{.monday-demo-tabs-asset-back-click-wrapper{content:"";position:absolute;top:0;height:100%;width:60px;background:transparent;z-index:', z_index/* LAYER_TWO */.wc, ';}.monday-demo-tabs-asset-wrapper{.asset-inner{.window-mask{padding-left:0;padding-right:0;.window-header{border-radius:0;}video{border-radius:0;}}}}.monday-demo-tabs-asset-wrapper.current{position:relative;}}}.mobile-tabs-navigation{overflow-x:auto;&::-webkit-scrollbar{display:none;}display:flex;gap:8px;padding-left:16px;.tab-nav-button-wrapper{display:flex;white-space:nowrap;}&::after{content:"";padding-right:16px;}}');

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-mobile-timeline/monday-demo-mobile-timeline.scss.js



var PROGRESS_BARS_GAP = 8;
var PROGRESS_BARS_GAP_STRING = "".concat(PROGRESS_BARS_GAP, "px");
var monday_demo_mobile_timeline_scss_PROGRESS_BAR_WIDTH = 36;
var monday_demo_mobile_timeline_scss_PROGRESS_BAR_WIDTH_STRING = "".concat(monday_demo_mobile_timeline_scss_PROGRESS_BAR_WIDTH, "px");
var StyledMondayDemoMobileTimeline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eu6njay0"
})("display:flex;gap:", PROGRESS_BARS_GAP_STRING, ";flex-direction:row;padding:16px 32px 0;&.dark-theme{.timeline-tab-indication-label-and-progress-bar-wrapper{.timeline-progress-bar-wrapper{.timeline-progress-bar{.timeline-progress-bar-empty,.timeline-progress-bar-filled{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}}.timeline-tab-indication-label-and-progress-bar-wrapper{display:flex;flex-direction:column;cursor:pointer;width:100%;&.selected{.timeline-progress-bar{.timeline-progress-bar-filled{width:100%;animation:fill-progress-bar linear;}}}&.watched{.timeline-tab-indication-and-label-wrapper{.timeline-tab-indication{opacity:1;}}.timeline-progress-bar-wrapper{.timeline-progress-bar{.timeline-progress-bar-filled{width:100%;}}}&.selected{.timeline-progress-bar-wrapper{.timeline-progress-bar{.timeline-progress-bar-filled{width:100%;}}}}}&:hover{.timeline-tab-indication-and-label-wrapper{.timeline-tab-indication{opacity:1;}}}.timeline-progress-bar-wrapper{width:100%;.timeline-progress-bar{width:100%;height:2px;display:flex;position:relative;.timeline-progress-bar-empty,.timeline-progress-bar-filled{border-radius:", monday_demo_mobile_timeline_scss_PROGRESS_BAR_WIDTH_STRING, ";background-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";height:100%;}.timeline-progress-bar-empty{width:100%;opacity:0.24;}.timeline-progress-bar-filled{width:0%;position:absolute;left:0;transition:height 0.15s ease-in-out;}}}}@keyframes fill-progress-bar{from{width:0;}to{width:100%;}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-mobile-timeline/monday-demo-mobile-timeline.js




var MondayDemoMobileTimeline = function(props) {
    var tabs = props.tabs, selectedTab = props.selectedTab, wasComponentEverVisible = props.wasComponentEverVisible, videoDuration = props.videoDuration, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMondayDemoMobileTimeline, {
        className: classnames_default()("monday-demo-tabs-timeline-and-labels-wrapper", {
            "dark-theme": (0,segments_service/* isDarkTheme */.$o)(theme)
        }),
        role: "tablist",
        children: tabs.map(function(tab, index) {
            var isSelected = index === selectedTab;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("timeline-tab-indication-label-and-progress-bar-wrapper", {
                    selected: isSelected && wasComponentEverVisible,
                    watched: index <= selectedTab
                }),
                children: index < tabs.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "timeline-progress-bar-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "timeline-progress-bar",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "timeline-progress-bar-empty"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "timeline-progress-bar-filled",
                                style: {
                                    animationDuration: index <= selectedTab ? "".concat(videoDuration, "s") : "unset"
                                }
                            })
                        ]
                    })
                })
            });
        })
    });
};
/* harmony default export */ var monday_demo_mobile_timeline = (MondayDemoMobileTimeline);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-mobile-component/monday-demo-tabs-mobile-component.js

function monday_demo_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_demo_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_demo_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_demo_tabs_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_demo_tabs_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_demo_tabs_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var MondayDemoTabsMobileComponent = function(props) {
    var tabs = props.tabs;
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var ref2 = (0,react.useState)(false), wasComponentEverVisible = ref2[0], setWasComponentEverVisible = ref2[1];
    var ref3 = (0,react.useState)([]), videoDurations = ref3[0], setVideoDurations = ref3[1];
    var itemsRef = (0,react.useRef)([]);
    var theme = props.theme;
    var VISIBILITY_SENSOR_OFFSET = -200;
    var tabsWithVideoPlayerRefs = [];
    tabs.forEach(function(tab) {
        tabsWithVideoPlayerRefs.push(monday_demo_tabs_mobile_component_object_spread_props(monday_demo_tabs_mobile_component_object_spread({}, tab), {
            videoPlayerRef: (0,react.useRef)(null)
        }));
    });
    (0,react.useEffect)(function() {
        var _currentTab_videoPlayerRef, _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current, _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef, _tabsWithVideoPlayerRefs_selectedTab_asset_video, _tabsWithVideoPlayerRefs_selectedTab_asset, _tabsWithVideoPlayerRefs_selectedTab;
        var currentTab = tabsWithVideoPlayerRefs[selectedTab];
        if (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_videoPlayerRef = currentTab.videoPlayerRef) === null || _currentTab_videoPlayerRef === void 0 ? void 0 : _currentTab_videoPlayerRef.current) {
            currentTab.videoPlayerRef.current.seekTo(0);
        }
        tabsWithVideoPlayerRefs === null || tabsWithVideoPlayerRefs === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab = tabsWithVideoPlayerRefs[selectedTab]) === null || _tabsWithVideoPlayerRefs_selectedTab === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset = _tabsWithVideoPlayerRefs_selectedTab.asset) === null || _tabsWithVideoPlayerRefs_selectedTab_asset === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset_video = _tabsWithVideoPlayerRefs_selectedTab_asset.video) === null || _tabsWithVideoPlayerRefs_selectedTab_asset_video === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef = _tabsWithVideoPlayerRefs_selectedTab_asset_video.videoPlayerRef) === null || _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current = _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef.current) === null || _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current === void 0 ? void 0 : _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current.seekTo(0);
    }, [
        selectedTab
    ]);
    var scrollToNavigationTabIfVisible = function(index) {
        if (isVisible) {
            var _itemsRef_current_index, _itemsRef_current;
            itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_index = _itemsRef_current[index]) === null || _itemsRef_current_index === void 0 ? void 0 : _itemsRef_current_index.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    var onTabNavButtonClick = function(param) {
        var tab = param.tab, index = param.index;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.DEMO_STEP_CLICKED, {
            kind: tab.tabLabel,
            info1: index
        });
        scrollToNavigationTabIfVisible(index);
        setSelectedTab(index);
    };
    var navigationItemRenderer = function(tab, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tab-nav-button-wrapper",
            ref: function(element) {
                return itemsRef.current[index] = element;
            },
            onClick: function() {
                return onTabNavButtonClick({
                    tab: tab,
                    index: index
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_tab_nav_plain_button, {
                tabNumber: index + 1,
                label: tab.tabLabel,
                selected: selectedTab === index,
                theme: theme
            })
        }, index);
    };
    var onVideoEnded = function(index) {
        if (index < tabsWithVideoPlayerRefs.length - 1) {
            var nextTabIndex = index + 1;
            setSelectedTab(nextTabIndex);
            scrollToNavigationTabIfVisible(nextTabIndex);
        }
    };
    var setVideoDuration = function(index, duration) {
        if (videoDurations[index] !== duration) {
            var newVideoDurations = (0,_to_consumable_array/* default */.Z)(videoDurations);
            newVideoDurations[index] = duration;
            setVideoDurations(newVideoDurations);
        }
    };
    var onVisibilityChange = function(isVisibleValue) {
        if (!wasComponentEverVisible && isVisibleValue) {
            setWasComponentEverVisible(true);
        }
        setIsVisible(isVisibleValue);
    };
    var onAssetClick = function() {
        var _tabsWithVideoPlayerRefs_selectedTab;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.DEMO_ASSET_CLICKED, {
            kind: tabsWithVideoPlayerRefs === null || tabsWithVideoPlayerRefs === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab = tabsWithVideoPlayerRefs[selectedTab]) === null || _tabsWithVideoPlayerRefs_selectedTab === void 0 ? void 0 : _tabsWithVideoPlayerRefs_selectedTab.tabLabel,
            info1: selectedTab
        });
        var nextTabIndex = Math.min(selectedTab + 1, tabsWithVideoPlayerRefs.length - 1);
        setSelectedTab(nextTabIndex);
        scrollToNavigationTabIfVisible(nextTabIndex);
    };
    var onLeftSideAssetClick = function(e) {
        var _tabsWithVideoPlayerRefs_selectedTab;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        e === null || e === void 0 ? void 0 : e.preventDefault();
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.DEMO_ASSET_LEFT_SIDE_CLICKED, {
            kind: tabsWithVideoPlayerRefs === null || tabsWithVideoPlayerRefs === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab = tabsWithVideoPlayerRefs[selectedTab]) === null || _tabsWithVideoPlayerRefs_selectedTab === void 0 ? void 0 : _tabsWithVideoPlayerRefs_selectedTab.tabLabel,
            info1: selectedTab
        });
        var nextTabIndex = Math.max(selectedTab - 1, 0);
        setSelectedTab(nextTabIndex);
        scrollToNavigationTabIfVisible(nextTabIndex);
    };
    var assetItemRenderer = function(tab, index) {
        var isSelected = index === selectedTab;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "monday-demo-tabs-asset-click-wrapper",
            onClick: onAssetClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "monday-demo-tabs-asset-back-click-wrapper",
                    onClick: onLeftSideAssetClick
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_demo_tabs_asset, {
                    selectedTab: selectedTab,
                    index: index,
                    isCurrent: isSelected,
                    asset: tab.asset,
                    onVideoEnded: function() {
                        return onVideoEnded(index);
                    },
                    autoPlay: isSelected && isVisible,
                    setVideoDuration: function(duration) {
                        return setVideoDuration(index, duration);
                    }
                })
            ]
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMondayDemoTabsMobileComponent, {
            className: "monday-demo-tabs-mobile-component",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_demo_mobile_timeline, {
                    theme: theme,
                    tabs: tabsWithVideoPlayerRefs,
                    selectedTab: selectedTab,
                    wasComponentEverVisible: wasComponentEverVisible,
                    videoDuration: videoDurations[selectedTab]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "monday-demo-tabs-assets-wrapper",
                    children: tabsWithVideoPlayerRefs.map(function(tab, index) {
                        return wasComponentEverVisible && index <= videoDurations.length ? assetItemRenderer(tab, index) : null;
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-tabs-navigation",
                    children: tabsWithVideoPlayerRefs.map(function(tab, index) {
                        return navigationItemRenderer(tab, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var monday_demo_tabs_mobile_component = (MondayDemoTabsMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/default-props.js


/* harmony default export */ var default_props = ({
    theme: color_consts.BACKGROUND_GRAY_COLOR_NAME,
    fullParagraph: {
        topic: {},
        title: "<light>See work management in </light><b>action</b>",
        body: "",
        textAlign: "center"
    },
    tabs: [
        {
            tabLabel: "Choose a template",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/1._Choose_a_template.mp4"
                    },
                    ariaLabel: "Demo of choosing a template"
                },
                useWindowMask: true
            }
        },
        {
            tabLabel: "Add your items",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/2._Add_your_items.mp4"
                    },
                    ariaLabel: "Demo of adding items"
                },
                useWindowMask: true
            }
        },
        {
            tabLabel: "Customize your board",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/3._Customize_your_board.mp4"
                    },
                    ariaLabel: "Demo of customizing a board"
                },
                useWindowMask: true
            }
        },
        {
            tabLabel: "Invite new members",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/4._Invite_new_members.mp4"
                    },
                    ariaLabel: "Demo of inviting new members"
                },
                useWindowMask: true
            }
        },
        {
            tabLabel: "Bring all your tools in",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/5._Bring_all_your_tools_in.mp4"
                    },
                    ariaLabel: "Demo of bringing all your tools in"
                },
                useWindowMask: true
            }
        },
        {
            tabLabel: "Automate routine work",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/6._Automate_routine_work.mp4"
                    },
                    ariaLabel: "Demo of automating routine work"
                },
                useWindowMask: true
            }
        },
        {
            tabLabel: "Communicate within items",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/7._Communicate_within_items.mp4"
                    },
                    ariaLabel: "Demo of communicating within items"
                },
                useWindowMask: true
            }
        },
        {
            tabLabel: "See where everything stands",
            autoTransition: "10000",
            asset: {
                video: {
                    src: {
                        singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/work%20management_new%20product%20page/demo_section/8._See_where_everything_stands.mp4"
                    },
                    ariaLabel: "Demo of seeing where everything stands"
                },
                useWindowMask: true
            }
        }
    ],
    buttonConfig: {
        buttonType: button_consts/* SIGNUP_BUTTON_TYPE */.ge
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-component.js




var MondayDemoTabsComponent = (0,responsive_hoc_component/* default */.Z)(monday_demo_tabs_desktop_component, monday_demo_tabs_mobile_component);
/* harmony default export */ var monday_demo_tabs_component = (MondayDemoTabsComponent);
MondayDemoTabsComponent.defaultProps = default_props;


/***/ })

}]);